import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';
import { nextActions } from '@app/store/next';
import { moduleActions } from '../actions/module.actions';

@Injectable({
    providedIn: 'root',
})
export class NextModuleBridge {
    private readonly actions = inject(Actions);

    onNextFetchGetModule$ = createEffect(() => {
        return this.actions.pipe(
            ofType(nextActions.getNextContentSuccess),
            map(({ payload }) => payload.moduleId),
            filter((moduleId) => moduleId !== null),
            map((moduleId) => moduleActions.getModule({ id: moduleId })),
        );
    });
}
